import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ChildHeader from "./childheader/ChildHeader";
import GrandChildHeader from "./grandchildheader/GrandChildHeader";
import CardHeader from "./HeaderCard/CardHeader";
import MainHeader from "./mainheader/MainHeader";

export const HeaderManagment: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const activeTab = query.get("activeTab");
  const subActiveTab = query.get("subActiveTab");

  // ✅ Default active tab (mainheader)
  useEffect(() => {
    if (!activeTab) {
      navigate(`${window.location.pathname}?activeTab=passengerHeader&subActiveTab=mainheader`, { replace: true });
    }
  }, [navigate, activeTab, subActiveTab]);

  // ✅ Tabs configuration
  const items = [
    { label: "Main Header", key: "mainheaders", children: <MainHeader /> },
    { label: "Child Header", key: "childheader", children: <ChildHeader /> },
    { label: "Grand Child Header", key: "grandchildheader", children: <GrandChildHeader /> },
    { label: "Airport Card Header", key: "cardheader", children: <CardHeader /> },
  ];

  // ✅ Dynamic action buttons
  const handleHeaderAction = (activeTab?: string | null) => {
    if (activeTab === "mainheaders") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/main/add")}
        >
          Add Main Header
        </Button>
      );
    }

    if (activeTab === "childheader") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/child/add")}
        >
          Add Child Header
        </Button>
      );
    }

    if (activeTab === "grandchildheader") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/grandchild/add")}
        >
          Add Grand Child Header
        </Button>
      );
    }
    if (activeTab === "cardheader") {
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/dedicated/passenger/navigation/header/cardheader/add")}
        >
          Add Card Header
        </Button>
      );
    }

    return null;
  };

  return (
    // <ContentWrapper
    //   title="Header Management"
    //   bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
    //   actionItems={handleHeaderAction(activeTab)}
    // >
    <>
      <Tabs
        activeKey={subActiveTab || "mainheaders"}
        items={items}
        onChange={(key) => navigate(`${window.location.pathname}?activeTab=passengerHeader&subActiveTab=${key}`)}
      />
    </>
  );
};

export default HeaderManagment;
